import indexArray from 'index-array';
import deepMerge from 'deepmerge';
import { Duck } from '@atc/modular-redux';
import selectors from './inventoryDuckSelectors.js';
const overwriteMerge = (_, sourceArray) => sourceArray;
export default function inventoryDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'inventory',
    storePath,
    initialState = {},
    ...rest
  } = _temp === void 0 ? {} : _temp;
  return new Duck({
    ...rest,
    namespace,
    store,
    storePath,
    consts: {},
    types: ['ADD_INVENTORY', 'SET_INVENTORY', 'UPDATE_INVENTORY_ITEM'],
    initialState,
    reducer: (state, action, _ref) => {
      let {
        types
      } = _ref;
      switch (action.type) {
        case types.ADD_INVENTORY:
          {
            // Deep merge the inventory objects to ensure that we are updating information correctly
            return deepMerge(state, action.payload, {
              arrayMerge: overwriteMerge
            });
          }
        case types.SET_INVENTORY:
          {
            return action.payload;
          }
        case types.UPDATE_INVENTORY_ITEM:
          {
            const {
              id,
              data = {}
            } = action.payload;
            return {
              ...state,
              [id]: deepMerge(state[id], data, {
                arrayMerge: overwriteMerge
              })
            };
          }
        default:
          return state;
      }
    },
    creators: _ref2 => {
      let {
        types
      } = _ref2;
      return {
        addInventory: data => {
          let inventory = data;

          // If inventory is passed as an array index it by id for lookup
          if (Array.isArray(data)) {
            inventory = indexArray(data, 'id');
          }
          return {
            type: types.ADD_INVENTORY,
            payload: inventory
          };
        },
        setInventory: data => {
          let inventory = data;

          // If inventory is passed as an array index it by id for lookup
          if (Array.isArray(data)) {
            inventory = indexArray(data, 'id');
          }
          return {
            type: types.SET_INVENTORY,
            payload: inventory
          };
        },
        updateInventoryItem: (id, data) => ({
          type: types.UPDATE_INVENTORY_ITEM,
          payload: {
            id,
            data
          }
        })
      };
    },
    selectors
  });
}